import { PageLocatorMap } from '../types/PageLocatorMap';

export const duplicateApplicationPage = {
  footer: {
    root: 'duplicate-application-page.footer.root',
  },
  main: {
    accountButton: 'duplicate-application-page.main.account-button',
    activeBrandBadge: 'duplicate-application-page.main.active-brand-badge',
    duplicateBrandBadge:
      'duplicate-application-page.main.duplicate-brand-badge',
    h1: 'duplicate-application-page.main.heading1',
    h2: 'duplicate-application-page.main.heading2',
    linkIcon: 'duplicate-application-page.main.link-icon',
    notice: 'duplicate-application-page.main.notice',
    root: 'duplicate-application-page.main.root',
  },
} as const satisfies PageLocatorMap;
